function getCmsInfoForPage(pageProps) {
  var _a, _b, _c, _d, _e, _f;
  if (!pageProps) {
    return {};
  }
  const cmsInfo = {};
  let categories;
  let tags;
  let pageIdentifiers;
  let postType;
  let authorName;
  if ("post" in pageProps) {
    categories = pageProps.post.categories;
    tags = pageProps.post.postTags;
    pageIdentifiers = ((_a = pageProps.post) == null ? void 0 : _a.pageIdentifiers) || [];
    postType = (_b = pageProps.post) == null ? void 0 : _b.type;
    authorName = (_d = (_c = pageProps.post) == null ? void 0 : _c.author) == null ? void 0 : _d.name;
  } else if ("category" in pageProps) {
    categories = [{
      slug: pageProps.category.slug
    }];
  } else if ("tag" in pageProps) {
    tags = [{
      slug: pageProps.tag.slug
    }];
  }
  if ("page" in pageProps) {
    pageIdentifiers = ((_e = pageProps.page) == null ? void 0 : _e.pageIdentifiers) || [];
    postType = ((_f = pageProps.page) == null ? void 0 : _f.type) || "page";
  }
  if (categories == null ? void 0 : categories.length) {
    cmsInfo.taxonomy_categories_txt = categories.map((category) => category.slug);
  }
  if (tags == null ? void 0 : tags.length) {
    cmsInfo.taxonomy_tags_txt = tags.map((tag) => tag.slug);
  }
  if (pageIdentifiers == null ? void 0 : pageIdentifiers.length) {
    cmsInfo.taxonomy_page_identifier_txt = pageIdentifiers.map((pageIdentifier) => pageIdentifier.slug);
  }
  if (postType) {
    cmsInfo.post_type = postType;
  }
  if (authorName) {
    cmsInfo.author_name = authorName;
  }
  if (pageProps.siteSlug) {
    cmsInfo.site_slug = pageProps.siteSlug;
  }
  return cmsInfo;
}
export {
  getCmsInfoForPage
};
